import { IUser } from '@interfaces/IUser';
import { EUserActions, UserActions } from './user.actions';
import { initialUserState, IUserState } from './user.state';

export const userReducers = (
  state = initialUserState,
  action: UserActions
): IUserState => {
  switch (action.type) {
    case EUserActions.UserInfoLoadingForTabs:
      return {
        ...state,
        profileTabsLoading: action.payload,
      };
    case EUserActions.GetUsers: {
      return {
        ...state,
        loading: { ...state.loading, getAll: true },
      };
    }
    case EUserActions.GetUnconfirmedCountSuccess: {
      return { ...state, unconfirmedCount: action.count };
    }
    case EUserActions.GetUsersSuccess: {
      return {
        ...state,
        users: action.payload.results,
        count: action.payload.count,
        loading: { ...state.loading, getAll: false },
      };
    }
    case EUserActions.GetUsersFailure: {
      return {
        ...state,
        loading: { ...state.loading, getAll: false },
      };
    }
    case EUserActions.StartRegisterLoading: {
      return {
        ...state,
        loading: { ...state.loading, register: true },
      };
    }
    case EUserActions.RegisterSuccess: {
      return {
        ...state,
        loading: { ...state.loading, register: false },
      };
    }

    case EUserActions.GetUserSuccess: {
      return {
        ...state,
        selectedUser: action.payload,
        loading: { ...state.loading, get: false },
      };
    }
    case EUserActions.GetUserFailure: {
      return {
        ...state,
        selectedUser: null,
        loading: { ...state.loading, get: false },
      };
    }
    case EUserActions.GetUser: {
      return { ...state, loading: { ...state.loading, get: true } };
    }
    case EUserActions.RequestFailure: {
      return {
        ...state,
        errors: action.errors,
        loading: {},
      };
    }
    case EUserActions.ImportUsersFailure: {
      return {
        ...state,
        importErrors: action.error,
        loading: { ...state.loading, importUsers: false },
      };
    }
    case EUserActions.ImportUsers: {
      return {
        ...state,
        loading: { ...state.loading, importUsers: true },
      };
    }
    case EUserActions.ImportUsersSuccess: {
      return {
        ...state,
        loading: { ...state.loading, importUsers: false },
        importSkipped: action.skipped || null,
        importErrors: null,
      };
    }
    case EUserActions.ImportSkippedReset: {
      return {
        ...state,
        importSkipped: null,
      };
    }
    case EUserActions.ImportErrorReset: {
      return {
        ...state,
        importErrors: null,
      };
    }
    case EUserActions.GetUserGroups: {
      return {
        ...state,
        loading: { ...state.loading, groups: true },
      };
    }
    case EUserActions.GetUserGroupsSuccess: {
      return {
        ...state,
        groups: action.payload,
        loading: { ...state.loading, groups: false },
      };
    }
    case EUserActions.GetUserGroupsFailure: {
      return {
        ...state,
        loading: { ...state.loading, groups: false },
      };
    }
    case EUserActions.CreateUser: {
      return {
        ...state,
        loading: { ...state.loading, create: true },
      };
    }
    case EUserActions.CreateUserSuccess: {
      return {
        ...state,
        users: [...state.users, action.user],
        loading: { ...state.loading, create: false },
      };
    }
    case EUserActions.CreateUserFailure: {
      return {
        ...state,
        error: { ...state.error, create: { ...action.errors } },
        loading: { ...state.loading, create: false },
      };
    }
    case EUserActions.EditUser: {
      return {
        ...state,
        loading: { ...state.loading, edit: true },
      };
    }
    case EUserActions.EditUserFailure: {
      return {
        ...state,
        error: { ...state.error, edit: { ...action.errors } },
        loading: { ...state.loading, edit: false },
      };
    }
    case EUserActions.DeleteUser: {
      return {
        ...state,
        loading: { ...state.loading, delete: true },
      };
    }
    case EUserActions.DeleteUserSuccess: {
      return {
        ...state,
        loading: { ...state.loading, delete: false },
      };
    }
    case EUserActions.EditUserSuccess: {
      const userIndex = state.users?.findIndex(u => u.id === action.user.id);
      const stateUsersCopy = [...state.users];
      if (~userIndex) {
        stateUsersCopy.splice(userIndex, 1, action.user);
      }
      return {
        ...state,
        users: stateUsersCopy,
        loading: { ...state.loading, edit: false },
      };
    }

    case EUserActions.DeleteHappyPoint:
      return {
        ...state,
        selectedUser: deleteHappyPoint(state.selectedUser, action.period),
      };

    case EUserActions.ClearStateUsers: {
      return { ...state, users: [] };
    }
    default:
      return state;
  }
};

const deleteHappyPoint = (data: IUser | null, period: number) => {
  if (data && data.happy_point_creds) {
    return {
      ...data,
      happy_point_creds: [
        {
          ...data.happy_point_creds[0],
          happy_point_using_periods:
            data.happy_point_creds[0].happy_point_using_periods.filter(
              happyPoint => happyPoint.period.id !== period
            ),
        },
      ],
    };
  }

  return data;
};
